export enum DragDropTypes {
  ANSWER = 'answer',
}
